import React from 'react';

const NoteRemoveIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.97 1H3.03C1.76 1 1 1.76 1 3.03V5.97C1 7.24 1.76 8 3.03 8H5.97C7.24 8 8 7.24 8 5.97V3.03C8 1.76 7.24 1 5.97 1ZM6.47 5.56C6.72 5.81 6.72 6.22 6.47 6.47C6.34 6.59 6.17 6.65 6.01 6.65C5.85 6.65 5.69 6.59 5.56 6.47L4.49 5.41L3.45 6.47C3.32 6.59 3.16 6.65 2.98 6.65C2.82 6.65 2.66 6.59 2.53 6.47C2.28 6.22 2.28 5.81 2.53 5.56L3.6 4.5L2.54 3.45C2.29 3.2 2.29 2.79 2.54 2.54C2.79 2.29 3.2 2.29 3.45 2.54L4.49 3.6L5.55 2.54C5.8 2.29 6.21 2.29 6.46 2.54C6.71 2.79 6.71 3.2 6.46 3.45L5.41 4.5L6.47 5.56Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M16.63 2H7.78C7.92 2.29 8 2.63 8 3.03V5.97C8 7.24 7.24 8 5.97 8H3.03C2.84 8 2.67 7.98 2.5 7.94V17.13C2.5 19.82 4.68 22 7.37 22H15.34C15.51 22 15.68 21.94 15.81 21.8C17.29 20.31 19.87 17.71 21.32 16.25C21.45 16.12 21.5 15.97 21.5 15.82V6.87C21.5 4.18 19.32 2 16.63 2Z"
      fill="white"
    />
    <path
      d="M21.5014 15.8202C21.5014 15.9702 21.4514 16.1202 21.3214 16.2502C19.8714 17.7102 17.2914 20.3102 15.8114 21.8002C15.6814 21.9402 15.5114 22.0002 15.3414 22.0002C15.0114 22.0002 14.6914 21.7402 14.6914 21.3602V17.8602C14.6914 16.4002 15.9314 15.1902 17.4514 15.1902C18.4014 15.1802 19.7214 15.1802 20.8514 15.1802C21.2414 15.1802 21.5014 15.4902 21.5014 15.8202Z"
      fill="white"
    />
    <path
      d="M14.7794 12.71H7.35938C6.93938 12.71 6.60938 12.37 6.60938 11.96C6.60938 11.55 6.94938 11.21 7.35938 11.21H14.7794C15.1994 11.21 15.5294 11.55 15.5294 11.96C15.5294 12.37 15.1994 12.71 14.7794 12.71Z"
      fill="white"
    />
    <path
      d="M11.9994 16.4199H7.35938C6.93938 16.4199 6.60938 16.0799 6.60938 15.6699C6.60938 15.2499 6.94938 14.9199 7.35938 14.9199H11.9994C12.4194 14.9199 12.7494 15.2599 12.7494 15.6699C12.7494 16.0799 12.4194 16.4199 11.9994 16.4199Z"
      fill="white"
    />
  </svg>
);

export default NoteRemoveIcon;
